import React, { useEffect, useState, useRef } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { API_URL, GOOGLE_MAPS_API_KEY } from "./config";
import carIcon from './—Pngtree—yellow car top view_14599687.png'; 

const mapContainerStyle = {
  width: '100%',
  height: '100vh',
};

const Driversdisplay = () => {
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const mapRef = useRef(null);
  const [previousDriverStates, setPreviousDriverStates] = useState({});
  const [initialCenter, setInitialCenter] = useState({ lat: -17.8292, lng: 31.0522 });
  const hasCenteredRef = useRef(false);

  const toFiniteNumber = (value) => {
    if (value === null || value === undefined) return null;
    const trimmed = typeof value === 'string' ? value.trim() : value;
    if (trimmed === '') return null;
    const n = typeof trimmed === 'number' ? trimmed : Number(trimmed);
    return Number.isFinite(n) ? n : null;
  };

  const getLatLng = (driver) => {
    const lat = toFiniteNumber(driver?.lat_cordinates);
    const lng = toFiniteNumber(driver?.long_cordinates);
    if (lat === null || lng === null) return null;
    if (lat === 0 && lng === 0) return null; // (0,0) means no real fix, not "null island"
    return { lat, lng };
  };

  useEffect(() => {
    const fetchDriverData = async () => {
      try {
        const response = await fetch(`${API_URL}/driver`);
        const data = await response.json();
        
        const updatedDrivers = data.map(driver => {
          const previous = previousDriverStates[driver.driver_id];
          let bearing = null;
          
          if (previous) {
            const prevLat = toFiniteNumber(previous.lat_cordinates);
            const prevLng = toFiniteNumber(previous.long_cordinates);
            const nextLat = toFiniteNumber(driver.lat_cordinates);
            const nextLng = toFiniteNumber(driver.long_cordinates);
            if (prevLat !== null && prevLng !== null && nextLat !== null && nextLng !== null) {
              bearing = calculateBearing(prevLat, prevLng, nextLat, nextLng);
            }
          }
          
          return { ...driver, bearing };
        });
        
        setDrivers(updatedDrivers);
        if (!hasCenteredRef.current) {
          const firstPos = updatedDrivers.map(getLatLng).find(Boolean);
          if (firstPos) {
            setInitialCenter(firstPos);
            hasCenteredRef.current = true;
          }
        }
        setPreviousDriverStates(prevStates => {
          const newStates = { ...prevStates };
          data.forEach(driver => {
            newStates[driver.driver_id] = { lat_cordinates: driver.lat_cordinates, long_cordinates: driver.long_cordinates };
          });
          return newStates;
        });
      } catch (error) {
        console.error('Error fetching driver data:', error);
      }
    };

    fetchDriverData();
    const interval = setInterval(fetchDriverData, 5000);

    return () => clearInterval(interval);
  }, [previousDriverStates]);

  const calculateBearing = (lat1, lon1, lat2, lon2) => {
    const toRadians = (degrees) => (degrees * Math.PI) / 180;
    const toDegrees = (radians) => (radians * 180) / Math.PI;

    const dLon = toRadians(lon2 - lon1);
    const y = Math.sin(dLon) * Math.cos(toRadians(lat2));
    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) -
              Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLon);
    const bearing = toDegrees(Math.atan2(y, x));
    return (bearing + 360) % 360; // normalize to 0-360
  };

  return (
    <div className="relative h-screen">
      <LoadScript
        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      >
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={initialCenter}
          zoom={15}
          onLoad={(map) => (mapRef.current = map)}
        >
          {drivers
            .map((driver, index) => ({ driver, index, pos: getLatLng(driver) }))
            .filter((x) => x.pos)
            .map(({ driver, index, pos }) => (
              <Marker
                key={index}
                position={pos}
                icon={{
                  url: carIcon,
                  scaledSize: new window.google.maps.Size(30, 30),
                  rotation: driver.bearing || 0,
                }}
                onClick={() => setSelectedDriver(driver)}
              />
            ))}
          {selectedDriver && (
            <InfoWindow
              position={getLatLng(selectedDriver) || { lat: -17.8292, lng: 31.0522 }}
              onCloseClick={() => setSelectedDriver(null)}
            >
              <div>
                <h2>{selectedDriver.name}</h2>
                <p>Direction: {selectedDriver.bearing ? `${selectedDriver.bearing.toFixed(2)}°` : 'N/A'}</p>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default Driversdisplay;